import React, { useState } from "react";

const OnboardingPage = ({ setCurrentPage }) => {
  const [pageNumber, setPageNumber] = useState(1);

  const nextPage = () => {
    setPageNumber(pageNumber + 1);
  };
  const previousPage = () => {
    setPageNumber(pageNumber - 1);
  };

  const pageContent = () => {
    switch (pageNumber) {
      case 1:
        return (
          <>
            <h2>congrats!</h2>
            <br></br>
            <h3>
              you are taking the first step to achieving your goals and building
              a healthier, more fulfilling life!
            </h3>
          </>
        );
      case 2:
        return (
          <>
            <h2>what is THE DRAGON?</h2>
            <br></br>
            <div>
              <h4>THE DRAGON represents the inner struggles we all face</h4>

              <h4>
                paying THE DRAGON means confronting these challenges head-on,
                helping you feel more empowered, and moving you closer to your
                goals
              </h4>

              <h4>
                when you choose to not PAY THE DRAGON, the impact can vary, but
                over time, you may notice feelings of dissatisfaction, lack of
                confidence, or a sense of being stuck
              </h4>

              <h4>
                by making the decision to PAY THE DRAGON, you're taking an
                important step towards a more fulfilled, confident, and
                successful you
              </h4>
            </div>
          </>
        );
      case 3:
        return (
          <>
            <h2>what are payments?</h2>
            <br></br>
            <div>
              <h3>
                payments are simple daily tasks that are not normally
                prioritized, but should be
              </h3>
              <br></br>
              <h3>
                add daily payments that you believe will enhance your personal
                growth and long-term well-being
              </h3>
            </div>
          </>
        );
      case 4:
        return (
          <>
            <h2>payment examples</h2>
            <br></br>
            <div style={{ textAlign: "left" }}>
              <h3>* 20 push-ups</h3>
              <h3>* meditate</h3>
              <h3>* read 5 pages</h3>
              <h3>* watch the sunset</h3>
              <h3>* drink green tea</h3>
              <h3>* journal</h3>
              <h3>* practice gratitude</h3>
              <h3>* compliment someone</h3>
            </div>
          </>
        );
      case 5:
        return (
          <>
            <h2>payment (pro tips):</h2>
            <div style={{ textAlign: "left", marginTop: "3rem" }}>
              <h4>
                * focus on your own well-being, rather than external
                responsibilities like family, work, or school
              </h4>
              <h4>
                * choose payments that lead to your bigger goal (ie: "20
                pushups" and not "lose 5 lbs")
              </h4>
              <h4>
                * make payments vague or specific when appropriate (ie:
                "Meditate" or "Meditate - 10 min")
              </h4>
              <h4>
                * set payments that are action-oriented (e.g., "stretch") rather
                than avoidance-based (e.g., "no smoking")
              </h4>
              <h4>* choose payments that you believe will better your life</h4>
            </div>
          </>
        );

      case 6:
        return (
          <>
            <h2>you're ready!</h2>
            <br></br>
            <h4>
              now it's time to start making small daily improvements that will
              add up to big changes
            </h4>
            <h4>start by adding your first payment and begin your journey!</h4>
            <button
              style={{
                marginTop: "2rem",
                padding: "1rem 2rem",
                fontSize: "1.2rem",
                backgroundColor: "#762f33",
                color: "white",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
              }}
              onClick={() => setCurrentPage("home")}
            >
              Start Improving Your Life
            </button>
          </>
        );
      default:
        setPageNumber(6);
        return null;
    }
  };

  const buttonStyle = {
    minHeight: "1rem",
    minWidth: "5rem",
    padding: ".01rem",
    position: "fixed",
  };

  return (
    <div style={{ padding: "1rem" }}>
      {pageContent()}
      {/* start bottom nav */}
      <div
        style={{
          position: "fixed",
          bottom: "4rem",
          display: "flex",
          alignItems: "center",
        }}
      >
        {pageNumber > 1 && (
          <button
            onClick={previousPage}
            style={{
              ...buttonStyle,
              backgroundColor: "rgb(88 77 78)",
              left: "2rem",
            }}
          >
            <h2>Back</h2>
          </button>
        )}
        {/* add conditional for last component */}
        {pageNumber !== 6 && (
          <button
            onClick={nextPage}
            style={{
              ...buttonStyle,
              backgroundColor: "#762f33",
              right: "2rem",
            }}
          >
            <h2>Next</h2>
          </button>
        )}
      </div>
    </div>
  );
};

export default OnboardingPage;
